import jwtDecode, { JwtPayload } from 'jwt-decode';

export interface Token {
  access_token: string;
  refresh_token: string;
  id_token: string;
}

export function getToken(): Token | null {
  const token = localStorage.getItem('token');
  try {
    return token?.length ? (JSON.parse(token) as Token) : null;
  } catch {
    return null;
  }
}

export function setToken(token: Token): void {
  localStorage.setItem('token', JSON.stringify(token));
}

export function removeToken(): void {
  localStorage.removeItem('token');
}

export function getExpirationDate(token: string): Date {
  const { exp } = jwtDecode<JwtPayload>(token);
  return new Date((exp ?? 0) * 1000);
}
